import { useEffect } from 'react';
import classNames from 'classnames';
import Styles from './CreateObject.module.scss';
import CMSObjectForm from './CMSObjectForm';
import DateSelect from '../../../../../components/UI/Input/DateSelect/DateSelect';
const CreateObject = props => {
	//set Created by and updated by to current user

	useEffect(() => {
		props.setUpdateObject({
			...props.updateObject,
			CreateUser: props.currentUser.userProfile.NetworkID,
			MaintUser: props.currentUser.userProfile.NetworkID,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.currentUser]);

	useEffect(() => {
		props.setUpdateObject({
			...props.updateObject,
			ObjectType: getType(),
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.updateObject.ObjectTypeID]);

	useEffect(() => {
		if (props.updateObject.ObjectTypeID === null && props.types[0]) {
			props.setUpdateObject({
				...props.updateObject,
				ObjectTypeID: props.types[0].ID,
			});

			props.setSelectedType(props.types[0]);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.types]);

	const getType = () => {
		let newType = props.types.find(type => {
			return type.ID === props.updateObject.ObjectTypeID;
		});
		return newType;
	};

	const handleChange = e => {
		props.setUpdateObject({
			...props.updateObject,
			[e.target.name]: e.target.value,
		});

		props.setWasEdited(true);
	};

	const handleTypeChange = e => {
		props.setUpdateObject({
			...props.updateObject,
			ObjectTypeID: parseInt(e.target.value),
		});

		props.setSelectedType(
			props.types.find(type => type.ID === parseInt(e.target.value))
		);
	};

	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth();
	const currentDay = new Date().getDate();

	const TypeDropdown = ({ options, name, onChange }) => {
		// return props.updateObject.ObjectTypeID != null ? (
		return (
			<select
				value={props.updateObject.ObjectTypeID}
				onChange={e => handleTypeChange(e)}
				placeholder='--Select Object Type--'
				name={name}
				className={Styles.input}
				id='TypeDropdown'
			>
				{options.map(type => {
					return (
						<option
							key={`${type.ID} + ${type.Name}`}
							id={type.ID}
							value={type.ID}
						>
							{type.Name}
						</option>
					);
				})}
			</select>
		);
	};

	return (
		<>
			<div className={props.Styles.DetailLabel}>Description</div>

			<textarea
				className={classNames(
					props.Styles.Section,
					props.Styles.textarea
				)}
				placeholder='Description'
				onChange={e => handleChange(e)}
				name='Description'
				id='Description_TextArea'
			/>
			{props.displayValidationError('Description')}
			<div className={props.Styles.DetailsContainer}>
				<div className={props.Styles.flexRow}>
					<div>
						<div>
							<span className={props.Styles.DetailLabel}>
								Start Date
							</span>
							<DateSelect
								name='StartDate'
								onChange={handleChange}
								value={new Date()}
								extras={{
									yearStart: currentYear,
									yearEnd: currentYear + 10,
								}}
							/>
						</div>

						<div>
							<span className={props.Styles.DetailLabel}>
								End Date
							</span>
							<DateSelect
								name='EndDate'
								onChange={handleChange}
								value={
									new Date(
										currentYear + 1,
										currentMonth,
										currentDay
									)
								}
								extras={{
									yearStart: currentYear,
									yearEnd: currentYear + 10,
								}}
							/>
						</div>
						<div>
							<div className={props.Styles.DetailLabel}>Type</div>
							<TypeDropdown
								options={props.types}
								name='CMSObjectTypeID'
							/>
						</div>
					</div>
				</div>
			</div>
			<CMSObjectForm {...props} />
		</>
	);
};

export default CreateObject;
